import { render } from "./slidehand-24.vue?vue&type=template&id=508d98cc&scoped=true"
import script from "./slidehand-24.vue?vue&type=script&lang=js"
export * from "./slidehand-24.vue?vue&type=script&lang=js"

import "./slidehand-24.vue?vue&type=style&index=0&id=508d98cc&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508d98cc"]])

export default __exports__